import {_baseRoute} from '../constants/public-routes';
import {LANGUAGES} from '../constants/dia';

export default class diaHelper {

  static formatAnnotationBody(body, lang = LANGUAGES[0]) {
    return body.replace(/(dia:\/\/)(concept)\/(\d+)/g, _baseRoute(lang) + '/concept/$2_$3');
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/diaHelper.js
 **/